import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

export class ApiError extends Error implements AxiosError {
  public readonly code?: string;
  public readonly config: AxiosRequestConfig;
  public readonly original?: AxiosError;
  // tslint:disable-next-line: no-any
  public readonly request?: any;
  public readonly response?: AxiosResponse;

  constructor(msg: string, err?: AxiosError) {
    super('[APIError] ' + msg);
    this.name = new.target.name;
    this.config = err ? err.config : {};
    this.code = err ? err.code : undefined;
    this.original = err;
    this.request = err ? err.request : undefined;
    this.response = err ? err.response : undefined;
    // some browsers don't captureStackTrace
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}

export class AuthenticationFailed extends ApiError {
  constructor(err?: AxiosError) {
    super('Authentication Failed.', err);
  }
}

export class InternalServerError extends ApiError {
  constructor(err?: AxiosError) {
    super('InternalServerError.', err);
  }
}

export class NotFound extends ApiError {
  constructor(err?: AxiosError) {
    super('Not Found.', err);
  }
}

export class ServiceTemporaryUnavailable extends ApiError {
  constructor(err?: AxiosError) {
    super('Service Temporary Unavailable.', err);
  }
}
